import { NavigateFunction } from 'react-router-dom'
import {
    FiUsers, FiFileText, FiSettings, FiHeadphones, FiClipboard,
} from 'react-icons/fi'
import { SidebarNavItem } from 'src/componentv2'
import homeIcon from 'src/assets/v2/img/home_icon.svg'
import reportIcon from 'src/assets/v2/img/report_icon.svg'
import checkPersonIcon from 'src/assets/v2/img/check_person_icon.svg'

export const getNavItems = (
    navigate: NavigateFunction,
    variant?: 1 | null,
): SidebarNavItem[] => {
    if (variant === 1) {
        return [
            {
                key: 'home',
                label: 'Home',
                icon: <img src={homeIcon} alt="" width={18} height={18} />,
            },
            {
                key: 'institutions',
                label: 'Institutions',
                icon: <FiUsers />,
                onClick: () => navigate('/dashboardv2/institution-list'),
            },
            {
                key: 'audit-trail',
                label: 'Audit Trail',
                icon: <FiFileText />,
            },
            {
                key: 'reports',
                label: 'Reports',
                icon: <img src={reportIcon} alt="" width={18} height={18} />,
            },
            {
                key: 'admin-users',
                label: 'Admin Users',
                icon: <img src={checkPersonIcon} alt="" width={18} height={18} />,
            },
            {
                key: 'survey-management',
                label: 'Survey Management',
                icon: <FiClipboard />,
                children: [
                    { key: 'survey-report', label: 'Survey Report', onClick: () => navigate('/dashboardv2/survey-report') },
                    { key: 'survey-management-triggers', label: 'Manage Triggers', onClick: () => navigate('/dashboardv2/survey-management') },
                ],
            },
        ]
    }

    return [
        {
            key: 'home',
            label: 'Home',
            icon: <img src={homeIcon} alt="" width={18} height={18} />,
            onClick: () => navigate('/dashboardv2/home'),
        },
        {
            key: 'customer-management',
            label: 'Customer Management',
            icon: <FiUsers />,
            children: [
                { key: 'customer-management-list', label: 'Customer List', onClick: () => navigate('/dashboardv2/customer-management-list') },
                { key: 'customer-management-cbp-list', label: 'CBP Customer List', onClick: () => navigate('/dashboardv2/customer-management-cbp-list') },
                { key: 'customer-management-account-upgrade', label: 'Account Upgrade', onClick: () => navigate('/dashboardv2/customer-management-account-upgrade') },
            ],
        },
        { key: 'audit-trail', label: 'Audit Trail', icon: <FiFileText />, onClick: () => navigate('/dashboardv2/audit-trail') },
        {
            key: 'reports',
            label: 'Reports',
            icon: <img src={reportIcon} alt="" width={18} height={18} />,
            onClick: () => navigate('/dashboardv2/reports'),
        },
        {
            key: 'staff-management',
            label: 'Staff Management',
            icon: <img src={checkPersonIcon} alt="" width={18} height={18} />,
            children: [
                { key: 'roles-permissions', label: 'Roles & Permissions', onClick: () => navigate('/dashboardv2/roles-permissions') },
                { key: 'team-members', label: 'Team Members', onClick: () => navigate('/dashboardv2/team-members') },
            ],
        },
        {
            key: 'configuration',
            label: 'Configuration',
            icon: <FiSettings />,
            children: [
                { key: 'institution-profile', label: 'Institution Profile', onClick: () => navigate('/dashboardv2/institution-profile') },
                { key: 'branding-setup', label: 'Branding Setup', onClick: () => navigate('/dashboardv2/institution-branding') },
                { key: 'business-logic', label: 'Business Logic', onClick: () => navigate('/dashboardv2/business-logic') },
                { key: 'app-generation', label: 'App Generation', onClick: () => navigate('/dashboardv2/app-generation') },
                { key: 'auto-deployment', label: 'Auto Deployment', onClick: () => navigate('/dashboardv2/auto-deployment') },
                { key: 'feed-notification', label: 'Feed & Notification', onClick: () => navigate('/dashboardv2/feed-notification') },
            ],
        },
        {
            key: 'support-management',
            label: 'Support Management',
            icon: <FiHeadphones />,
            onClick: () => navigate('/dashboardv2/support-management'),
        },
    ]
}

export default getNavItems